import type { ProductCard } from "@itaas/pep-contracts";

/** Produit visible sur le site public PEP (catalogue, essai, SEO). */
export function isPublicCatalogProduct(product: ProductCard): boolean {
  return product.publicCatalog !== false;
}

/** Fiche avec hero enrichi (stats, highlights ou groupes fonctionnels). */
export function hasRichProductPresentation(product: ProductCard): boolean {
  return Boolean(
    product.stats?.length ||
      product.highlights?.length ||
      product.featureGroups?.length,
  );
}

export function filterPublicCatalogProducts(products: ProductCard[]): ProductCard[] {
  return products.filter(isPublicCatalogProduct);
}
